import { createFeature, createReducer, on } from '@ngrx/store';
import { appConfigLoaded } from '../actions/app-config.actions';

export type AppConfig = {
  [key: string]: any;
};

export const APP_CONFIG_STATE_KEY = 'appConfig';

export type AppConfigState = {
  appConfig: AppConfig | null;
};

const initialState: AppConfigState = {
  appConfig: null,
};

const reducer = createReducer(
  initialState,
  on(appConfigLoaded, (state, { appConfig = {} }) => ({
    ...state,
    appConfig,
  })),
);

export const appConfigFeature = createFeature({
  name: APP_CONFIG_STATE_KEY,
  reducer,
});
